import { render } from "./favorite-activities.vue?vue&type=template&id=51159d9e"
import script from "./favorite-activities.vue?vue&type=script&lang=js"
export * from "./favorite-activities.vue?vue&type=script&lang=js"

import "./favorite-activities.vue?vue&type=style&index=0&id=51159d9e&lang=css"
script.render = render

export default script